import { useModel as _useModel, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "form-dialog__title" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "开票备注")
], -1)
const _hoisted_2 = { class: "form-dialog__content" }

import { ref, defineModel } from 'vue';
import { BaseForm, BaseFormItem, BaseInput } from 'xrk-components';
import { MakeOutAnInvoiceParams } from '@V/invoice/src/data-source/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'invoice-open-dialog-demand',
  props: {
    "modelValue": {},
    "modelModifiers": {},
  },
  emits: ["update:modelValue"],
  setup(__props) {

const formRef = ref(null);
const formData = _useModel<MakeOutAnInvoiceParams>(__props, "modelValue");

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseForm), {
    ref_key: "formRef",
    ref: formRef,
    "label-position": "top",
    model: formData.value
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(BaseFormItem), {
          label: "备注",
          prop: "demand"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(BaseInput), {
              class: "form-dialog__w280",
              type: "textarea",
              placeholder: "请输入",
              "show-word-limit": "",
              rows: 4,
              maxlength: 120,
              modelValue: formData.value.demand,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.demand) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["model"]))
}
}

})